module.exports = __webpack_public_path__ + "static/media/image-9.09d3505b.jpg";